export default __webpack_public_path__ + "26e5ed8304931f5db92d1f4dd358aa46.svg";